
namespace Matrix.Data {

    export interface SecurityMergeInspectionOptions {
        securityId: number;
    }

    @Serenity.Decorators.panel()
    export class SecurityMergeInspectionDialog extends Serenity.TemplatedDialog<SecurityMergeInspectionOptions> {

        private table: SecurityMergeInspectionTable;

        constructor(opt: SecurityMergeInspectionOptions) {
            super(opt);

            this.set_dialogTitle("Security " + this.options.securityId);

            this.table = new SecurityMergeInspectionTable(this.byId('InspectionTable'));
            SecurityService.List({
                ColumnSelection: Serenity.ColumnSelection.Details,
                EqualityFilter: {
                    SecurityId: this.options.securityId || -1
                }
            },
                response => {
                    var security = response.Entities[0] || {};
                    this.set_dialogTitle("Security " + this.options.securityId + ": " + Q.coalesce(security.Name, ""));
                    SecurityMergeService.List({
                        EqualityFilter: {
                            SecurityId: this.options.securityId || -1
                        },
                        Sort: ["SourceSecurityId"]
                    },
                        listResponse => {
                            this.table.setMergeData(security, listResponse.Entities || []);
                        }
                    );
                }
            );

            $(window).on('resize.' + this.uniqueName, () => this.arrange());
        }

        destroy() {
            $(window).off('.' + this.uniqueName);
            super.destroy();
        }

        protected getToolbarButtons() {
            return [
                {
                    title: 'View Security',
                    icon: 'fa-location-arrow',
                    cssClass: 'view-security-button',
                    onClick: () => {
                        var securityId = Q.toId(this.options.securityId);
                        if (securityId) {
                            SecurityService.List({
                                ColumnSelection: Serenity.ColumnSelection.KeyOnly,
                                IncludeColumns: [
                                    "SecurityId"
                                ],
                                EqualityFilter: {
                                    SecurityId: securityId
                                }
                            },
                                response => {
                                    if (!response.Entities.length) {
                                        Q.notifyError("This security does not yet exist!");
                                        return;
                                    }
                                    new SecurityDialog().loadByIdAndOpenDialog(securityId);
                                }
                            );
                        }
                    }
                },
                {
                    title: '',
                    hint: 'Show / hide blank rows',
                    icon: 'fa-arrows-v',
                    onClick: () => {
                        this.table.hideBlankRows = !this.table.hideBlankRows;
                    }
                },
                {
                    hint: 'Excel',
                    title: '',
                    cssClass: 'export-xlsx-button',
                    icon: 'fa-file-excel-o',
                    onClick: () => {
                        Q.postToService({
                            url: Q.resolveUrl('~/Report/TableExcelExport'),
                            request: <TableExcelExportRequest>{
                                Columns: this.table.slickGrid.getColumns().map(src => <TableExcelExportColumn>{
                                    Name: src.id || src.field,
                                    Title: src.name || '_'
                                }),
                                Data: gridDataToExcel(this.table.getItems(), this.table.slickGrid.getColumns())
                            },
                            target: '_blank'
                        });
                    }
                }
            ];
        }

        protected arrange() {
            super.arrange();
            this.byId("InspectionTable").css('height', Math.max(150, $(window).height() - 190) + 'px').trigger('layout');
        }

        protected getTemplate() {
            return `<div id="~_Toolbar"></div><div id="~_InspectionTable"></div>`;
        }
    }

    function gridDataToExcel(entities: any[], srcColumns: Slick.Column[]) {
        var el = document.createElement('span');
        var row = 0;
        return entities.map(function (item) {
            var dst = {};
            for (var cell = 0; cell < srcColumns.length; cell++) {
                var src = srcColumns[cell];
                var fld = src.field || '';
                var html = void 0;
                if (src.formatter) {
                    html = src.formatter(row, cell, item[fld], src, item);
                }
                else if (src.format) {
                    html = src.format({ row: row, cell: cell, item: item, value: item[fld] });
                }
                else {
                    dst[fld] = item[fld];
                    continue;
                }
                if (!html || (html.indexOf('<') < 0 && html.indexOf('&') < 0))
                    dst[fld] = html;
                else {
                    el.innerHTML = html;
                    if (el.children.length == 1 &&
                        $(el.children[0]).is(":input")) {
                        dst[fld] = $(el.children[0]).val();
                    }
                    else if (el.children.length == 1 &&
                        $(el.children).is('.check-box')) {
                        dst[fld] = $(el.children).hasClass("checked") ? "X" : "";
                    }
                    else
                        dst[fld] = el.textContent || '';
                }
            }
            row++;
            return dst;
        });
    }
}